<template>
  <button class="btn btn-warning float-right hidden-print" v-on:click="print()">
    <i class="fas fa-print"></i>
    {{ printButtonName }}
  </button>
</template>

<script>
export default {
  name: "Print",
  props: ["elementToPrintId", "buttonName"],
  data() {
    return {
      printButtonName: this.buttonName ?? "Drukuj"
    }
  },
  methods: {
    print() {
      this.$htmlToPaper(this.elementToPrintId);
    },
  },
};
</script>
